import React, { useEffect, useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import { Link, useNavigate } from "react-router-dom";
import { publicIpv4 } from "public-ip";
import JSEncrypt from "jsencrypt";
import Alerta from "../components/Alerta";

import useAuth from "../hooks/useAuth";
import {
  apiLogin,
  codigoApp,
  keyPassLogin,
  key_public_pem_encripted_login,
  loginCaptchaBackgroundColor,
  loginCaptchaFontoColor,
  loginCaptchaLong,
  paginaMantenimiento,
} from "../config/constantes";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import CryptoJS from "crypto-js";
import useMatricula from "../hooks/useMatricula";
import {
  loadCaptchaEnginge,
  CaptchaV2,
  validateCaptcha,
} from "../components/CaptchaV2/CaptchaV2";
import { handleSoloLetrasNumeros } from "../utils/utils";
import { validarCrearToken } from "../utils/validarTokenGlo/validarTokenGlo";
 

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [recordarUsuario, setRecordarUsuario] = useState(false);
  const [alerta, setAlerta] = useState({});
  const [oSName, setOSName] = useState("No es compatible");
  const [ipUser, setIpUser] = useState("No es compatible");
  const [navigatorName, setaNavigatorName] = useState("No es compatible");
  const [etiquetas, setEtiquetas] = useState({});
  const { setAuth, auth, listadoEtiquetas } = useAuth();
  const {
    setLoading,
    setPasoProcesoM,
    setPasoSegundaVistaProcesoM,
    setCkeckValidator,
    setResumenPagoEstudiante,
    setPensionesEstudiante,
    setCuotasPagosEstudiante,
    setCuotaSeleccionada,
    setListadoBancos,
    setListadoModalidadPagos,
    setErrorServices,
    setErrorCursoServices,
    setListadoAsignaturasEstudiante,
    setListEventos,
    setCambiarTextoBoton,
    setListAsignaturasAgregadas,
    setValidarListaHorario,
    setStrInsertarHorario,
    setMsgModalHorario,
    setCarritoHorario,
    setArchivoPeso,
    setSeleccionPdf,
    setListadoDatosPersonales,
    setObtenerReglamentoEstudios,
    setObtenerSegurosAccidentes,
    setObtenerEmpresasSegurosAccidentes,
    setObtenerSegurosAccidentesEstudiante,
  } = useProcesoMatricula();
  const {
    setListadoAsignaturas,
    setGruposHabilitados,
    setlistadoRequisitosMatricula,
    setListadoPrograma,
    setListadoInforMatriDocumento,
    setProcesoMatricula,
    setObtenerDatosEstudiante,
    setObtenerDatosEstudianteSinFiltro,
    setIdAsignaturas,
    setListadoSoporte,
    setListadoPeriodo,
    setSeleccionPrograma,
    setIdGruposHabilitados,
    setSeleccionPeriodo,
  } = useMatricula();
  const navigate = useNavigate();
  const captchaRef = useRef(null);
  const [showPass, setShowPass] = useState(false);
  const switchShowPass = () => setShowPass(!showPass);

  const getOS = async () => {
    if (navigator.userAgentData) {
       
      setaNavigatorName(navigator.userAgentData.brands[1].brand);
     
      setOSName(navigator.userAgentData.platform);
     

       
    }

   
    setIpUser(
      "IPv4 Publica: " +
        ((await publicIpv4()) ? await publicIpv4() : "No se pudo obtener")
    );
  };

   
  useEffect(() => {
     
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        olvidaste_contrasena: obtenerLabelEtiqueta(
          "lbl_login_olvidaste_contrasena",
          listadoEtiquetas
        ),
        global_dni: obtenerLabelEtiqueta("lbl_global_dni", listadoEtiquetas),
        global_contrasena: obtenerLabelEtiqueta(
          "lbl_login_contrasena",
          listadoEtiquetas
        ),
        recordar_usuario: obtenerLabelEtiqueta(
          "lbl_login_recordar_usuario",
          listadoEtiquetas
        ),
        ingresar: obtenerLabelEtiqueta("lbl_login_ingresar", listadoEtiquetas),
        iniciar_sesion: obtenerLabelEtiqueta(
          "lbl_login_iniciar_sesion",
          listadoEtiquetas
        ),
        lbl_validacion_msj_todos_campos: obtenerLabelEtiqueta(
          "lbl_validacion_msj_todos_campos",
          listadoEtiquetas
        ),
        lbl_validacion_msj_dni_invalido: obtenerLabelEtiqueta(
          "lbl_validacion_msj_dni_invalido",
          listadoEtiquetas
        ),
        lbl_validacion_credenciales_invalidas: obtenerLabelEtiqueta(
          "lbl_validacion_credenciales_invalidas",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  const {
    olvidaste_contrasena,
    global_dni,
    global_contrasena,
    recordar_usuario,
    ingresar,
    iniciar_sesion,
    lbl_validacion_msj_todos_campos,
    lbl_validacion_msj_dni_invalido,
    lbl_validacion_credenciales_invalidas,
  } = etiquetas;

  useEffect(() => {
    if (localStorage.getItem("recordarUsuario")) {
      const recordUser = JSON.parse(localStorage.getItem("recordarUsuario"));
      
      setEmail(recordUser.email);
      let descPass = desencriptarPass(recordUser.password);
      setPassword(descPass);
    }

    loadCaptchaEnginge(
      loginCaptchaLong,
      loginCaptchaBackgroundColor,
      loginCaptchaFontoColor
    );

    
    setObtenerDatosEstudiante([]);
    setObtenerDatosEstudianteSinFiltro([]);

    setListadoAsignaturas([]);
    setGruposHabilitados([]);
    setlistadoRequisitosMatricula([]);
    setListadoPrograma([]);
    setListadoInforMatriDocumento([]);
    setRecordarUsuario(false);
    setPasoProcesoM(0);
    setPasoSegundaVistaProcesoM(false);
    setCkeckValidator(false);
    setSeleccionPeriodo(null);
    setResumenPagoEstudiante([]);
    setPensionesEstudiante([]);
    setCuotasPagosEstudiante([]);
    setCuotaSeleccionada("");
    setListadoBancos([]);
    setListadoModalidadPagos({});
    setErrorServices(false);
    setErrorCursoServices("");
    setListadoAsignaturasEstudiante([]);

    setListEventos([]);
    setCambiarTextoBoton(false);

    setListAsignaturasAgregadas([]);
    setValidarListaHorario([]);

    setStrInsertarHorario([]);

    setMsgModalHorario({});

    setCarritoHorario({});

    setArchivoPeso({});

    setSeleccionPdf({});
    setListadoDatosPersonales([]);
    setObtenerReglamentoEstudios([]);
    setObtenerSegurosAccidentes([]);
    setObtenerEmpresasSegurosAccidentes([]);
    setObtenerSegurosAccidentesEstudiante([]);

    setProcesoMatricula({});
    setObtenerDatosEstudiante({});
    setObtenerDatosEstudianteSinFiltro([]);
    setIdAsignaturas({});
    setListadoSoporte([]);
    setListadoPeriodo([]);
    setSeleccionPrograma(null);
    setIdGruposHabilitados({});
    setAuth({});

    localStorage.removeItem("tokenGlo");
     
  }, []);

  

  const encryptData = (data) => {
    const publicKey = key_public_pem_encripted_login;

    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);

    let dataString = JSON.stringify(data);

    const encrypted = encrypt.encrypt(dataString);

    return encrypted;
  };

  const prometeValidarLogin = (api, config) => {
    return new Promise((resolver, rechazar) => {
      fetch(api, config)
        .then((data) => data.json())
        .then((json) => {
          if (json.StatusCode == 200) {
            resolver(json);
          } else {
            rechazar(new Error(json.Message));
          }
        });
    });
  };

  let desencriptarPass = (pass) => {
    
    var bytes = CryptoJS.AES.decrypt(pass, `${keyPassLogin}`);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);

    return originalText;
  };
  let encriptarPass = (pass) => {
   
    var ciphertext = CryptoJS.AES.encrypt(pass, `${keyPassLogin}`).toString();
    return ciphertext;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var dni = /^[A-Za-z0-9]{8,12}$/;

      if ([email, password].includes("")) {
        

        setAlerta({
          msg: `*${lbl_validacion_msj_todos_campos}.`,
          error: true,
        });

        return;
      }
      if (!dni.test(email)) {
        setAlerta({
          msg: `${lbl_validacion_msj_dni_invalido}.`,
          error: true,
        });
        return;
      }

      if (validateCaptcha(captcha) === false) {
        setAlerta({
          msg: "Validación captcha falló.",
          error: true,
        });
        setCaptcha("");
        return;
      }

      loadCaptchaEnginge(
        loginCaptchaLong,
        loginCaptchaBackgroundColor,
        loginCaptchaFontoColor
      );
      setCaptcha("");
       

      setLoading(true);
     
      const variablesEnvio = {
        user: email,
        password: password,
      };

      const variableEnvioIncriptada = {
        credenciales: encryptData(variablesEnvio),
      };

      let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          
        },
        body: JSON.stringify(variableEnvioIncriptada),
      };

      let loginServiceJson = await prometeValidarLogin(apiLogin, config);

      let { Data } = loginServiceJson;

      const { access_token, expires_in, key_encrypt } = Data;

      if (access_token && expires_in && key_encrypt) {
        if (!localStorage.getItem("token")) {
          if (recordarUsuario) {
           
            let encriptPass = encriptarPass(password);
            const recordUsuario = {
              email,
              password: encriptPass,
            };

            localStorage.setItem(
              "recordarUsuario",
              JSON.stringify(recordUsuario)
            );
          } else {
            localStorage.removeItem("recordarUsuario");
          }
        }

        let encriptPass = encriptarPass(email);

        localStorage.setItem("token", encriptPass);
      

        setAuth({
          _id: `${encriptPass}`,
        });

         
  
        let segundosAminutos = expires_in / 60;
        let currentDate = new Date();
        let fechaFuturaExpira = new Date(
          currentDate.getTime() + segundosAminutos * 60000
        );
  
  
        localStorage.setItem(
          "tokenGlo",
          JSON.stringify({
            access_token: access_token,
            expires_in: fechaFuturaExpira,
            key_encrypt:key_encrypt
          })
        );
        navigate("/");
      } else {
        setCaptcha("");
        setAlerta({
          msg: `${"Uno de estos datos es incorrecto: access_token, expires_in, key_encrypt"}.`,
          error: true,
        });
      }
    } catch (error) {
      setCaptcha("");
     

      setAlerta({
        msg: `${String(error).replace("Error:", "")}`,
        error: true,
      });

     
    } finally {
      setLoading(false);
    }

  
  };

  const { msg } = alerta;
  const soloNumeros = (e) => {
    let regex = new RegExp("^[A-Za-z0-9]+$");
    let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (!regex.test(key) || e.target.value.length === 15) {
      e.preventDefault();
      return false;
    }
  };
  
  if (paginaMantenimiento == "false") {
    return (
      <div className="login-content va-middle">
        
        <div className="center">
          <div className="log-title">
            <h1>{iniciar_sesion}</h1>
            <div className="separator"></div>
          </div>

          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            {msg && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ width: "100%" }}>
                  <Alerta alerta={alerta} />
                </div>
              </div>
            )}
            <div className="mb-4">
              <label
                htmlFor="exampleFormControlInput1"
                className="visually-hidden"
              >
                Email address
              </label>
              <div className="input-group flex-nowrap">
                <input
                  autoComplete="off"
                  type="text"
                  className="form-control login-control form-control-sm text-uppercase"
                  id="exampleFormControlInput1"
                  placeholder={global_dni}
                  value={email}
                  minLength="8"
                  maxLength="15"
                  onChange={(e) => {
                    setEmail(e.target.value.toUpperCase());
                  }}
                  onKeyPress={(e) => soloNumeros(e)}
                  onPaste={(e) => {
                    e.preventDefault();
                  }}
                />
                <span
                  className="input-group-text login-control "
                  id="addon-wrapping"
                >
                  {" "}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0002 3.33325C10.8842 3.33325 11.7321 3.68444 12.3572 4.30956C12.9823 4.93468 13.3335 5.78253 13.3335 6.66659C13.3335 7.55064 12.9823 8.39849 12.3572 9.02361C11.7321 9.64873 10.8842 9.99992 10.0002 9.99992C9.11611 9.99992 8.26826 9.64873 7.64314 9.02361C7.01802 8.39849 6.66683 7.55064 6.66683 6.66659C6.66683 5.78253 7.01802 4.93468 7.64314 4.30956C8.26826 3.68444 9.11611 3.33325 10.0002 3.33325ZM10.0002 4.99992C9.55814 4.99992 9.13421 5.17551 8.82165 5.48807C8.50909 5.80063 8.3335 6.22456 8.3335 6.66659C8.3335 7.10861 8.50909 7.53254 8.82165 7.8451C9.13421 8.15766 9.55814 8.33325 10.0002 8.33325C10.4422 8.33325 10.8661 8.15766 11.1787 7.8451C11.4912 7.53254 11.6668 7.10861 11.6668 6.66659C11.6668 6.22456 11.4912 5.80063 11.1787 5.48807C10.8661 5.17551 10.4422 4.99992 10.0002 4.99992ZM10.0002 10.8333C12.2252 10.8333 16.6668 11.9416 16.6668 14.1666V16.6666H3.3335V14.1666C3.3335 11.9416 7.77516 10.8333 10.0002 10.8333ZM10.0002 12.4166C7.52516 12.4166 4.91683 13.6333 4.91683 14.1666V15.0833H15.0835V14.1666C15.0835 13.6333 12.4752 12.4166 10.0002 12.4166Z"
                      fill="#5F5F5F"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="inputPassword2" className="visually-hidden">
                Password
              </label>
              <div className="input-group flex-nowrap">
                <input
                  autoComplete="off"
                  type={showPass ? "text" : "password"}
                  className="form-control login-control form-control-sm"
                  id="inputPassword2"
                  placeholder={global_contrasena}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <button
                  className="input-group-text login-control"
                  id="addon-wrapping"
                  onClick={switchShowPass}
                  type="button"
                >
                  <svg
                    width="20"
                    height="13"
                    viewBox="0 0 20 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0002 4.125C10.6632 4.125 11.2991 4.37522 11.7679 4.82062C12.2368 5.26602 12.5002 5.87011 12.5002 6.5C12.5002 7.12989 12.2368 7.73398 11.7679 8.17938C11.2991 8.62478 10.6632 8.875 10.0002 8.875C9.33712 8.875 8.70124 8.62478 8.2324 8.17938C7.76356 7.73398 7.50016 7.12989 7.50016 6.5C7.50016 5.87011 7.76356 5.26602 8.2324 4.82062C8.70124 4.37522 9.33712 4.125 10.0002 4.125ZM10.0002 0.5625C14.1668 0.5625 17.7252 3.02458 19.1668 6.5C17.7252 9.97542 14.1668 12.4375 10.0002 12.4375C5.8335 12.4375 2.27516 9.97542 0.833496 6.5C2.27516 3.02458 5.8335 0.5625 10.0002 0.5625ZM2.65016 6.5C4.02516 9.16 6.86683 10.8542 10.0002 10.8542C13.1335 10.8542 15.9752 9.16 17.3502 6.5C15.9752 3.84 13.1335 2.14583 10.0002 2.14583C6.86683 2.14583 4.02516 3.84 2.65016 6.5Z"
                      fill="#5F5F5F"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div></div>
            <label className="container-checkbox">
              {recordar_usuario}
              <input
                type="checkbox"
                onChange={(e) => {
                  setRecordarUsuario(!recordarUsuario);
                }}
              />
              <span className="checkmark"></span>
            </label>

            <div className="d-flex justify-content-center">
              <CaptchaV2 reloadText="Recargar Captcha" reloadColor="#B01333" />
            </div>

            <input
              autoComplete="off"
              type="text"
              className="form-control login-control form-control-sm"
              placeholder={"Ingrese captcha"}
              value={captcha}
              
              onChange={(e) => handleSoloLetrasNumeros(e, setCaptcha, 6)}

            
            />
            <div className="text-center mt-5">
              <button type="submit" className="btn btn-send mb-3">
                {ingresar}
              </button>
 
              <a
                href="https://intranet.upch.edu.pe/account/password-reset"
                className="mt-4 d-block"
                target="_blank"
              >
                {olvidaste_contrasena}
              </a>
            </div>
          </form>
        </div>
      </div>
    );
  } else {
    return (
      <div className="login-content va-middle">
        
        <div className="center">
          <div className="log-title">
            <h2 className="text-center">En mantenimiento</h2>
            <div className="separator"></div>
            <p className="ps-5 pe-5 mt-3">
              Estimado estudiante, le informamos que nuestra página se encuentra
              temporalmente en mantenimiento, con la finalidad de ofrecerle un
              mejor servicio, y se estará reactivando en unos minutos.
            </p>
            <p className="ps-5 pe-5 mt-3"> Gracias por su comprensión. </p>
          </div>
        </div>
      </div>
    );
  }
};

export default Login;
